import React from 'react';
import { FaMapMarkerAlt } from 'react-icons/fa';
import styled from 'styled-components';
import { BREAKPOINTS, COLORS, FONTS, SPACING } from '../../styles/variables';
import Section from '../Section/Section';

const CoverageContainer = styled.div`
  text-align: center;
`;

const SectionTitle = styled.h2`
  font-size: calc(${FONTS.SIZE_HEADING_2} * 1.1);
  color: ${COLORS.BLUE_MAIN};
  margin-bottom: ${SPACING.SMALL};
`;

const SectionSubtitle = styled.p`
  font-size: ${FONTS.SIZE_HEADING_3};
  color: ${COLORS.BLACK_TEXT}CC;
  margin-bottom: ${SPACING.LARGE};
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
`;

const Divider = styled.div`
  width: 80px;
  height: 4px;
  background-color: ${COLORS.SUCCESS};
  margin: 0 auto ${SPACING.LARGE};
  border-radius: 2px;
`;

const CitiesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${SPACING.LARGE};
  max-width: 620px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${SPACING.XLARGE};
  
  @media (min-width: ${BREAKPOINTS.TABLET}) {
    grid-template-columns: 1fr;
    gap: ${SPACING.XLARGE};
  }
`;

const CityCard = styled.div`
  background: linear-gradient(135deg, ${COLORS.WHITE} 0%, ${COLORS.WHITE}F5 100%);
  border-radius: ${SPACING.MEDIUM};
  padding: ${SPACING.LARGE};
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 2px solid transparent;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    border-color: ${COLORS.BLUE_MAIN}22;
  }
`;

const CityName = styled.h3`
  font-size: ${FONTS.SIZE_HEADING_2};
  color: ${COLORS.BLUE_MAIN};
  margin-bottom: ${SPACING.MEDIUM};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CityIcon = styled.span`
  margin-right: ${SPACING.SMALL};
  color: ${COLORS.SUCCESS};
  font-size: 24px;
`;

const CityDescription = styled.p`
  color: ${COLORS.BLACK_TEXT}DD;
  margin-bottom: ${SPACING.MEDIUM};
  line-height: 1.6;
`;



const GlobalStats = styled.div`
  background: linear-gradient(135deg, ${COLORS.BLUE_MAIN}11 0%, ${COLORS.BLUE_MAIN}05 100%);
  border-radius: ${SPACING.MEDIUM};
  padding: ${SPACING.LARGE};
  margin-top: ${SPACING.XLARGE};
`;

const GlobalStatsTitle = styled.h3`
  color: ${COLORS.BLUE_MAIN};
  font-size: ${FONTS.SIZE_HEADING_3};
  margin-bottom: ${SPACING.MEDIUM};
  text-align: center;
`;

const GlobalStatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${SPACING.LARGE};
  max-width: 500px;
  margin: 0 auto;
`;

const GlobalStatItem = styled.div`
  text-align: center;
`;

const GlobalStatValue = styled.div`
  font-size: calc(${FONTS.SIZE_HEADING_2} * 1.2);
  font-weight: ${FONTS.WEIGHT_BOLD};
  color: ${COLORS.BLUE_MAIN};
  margin-bottom: ${SPACING.XSMALL};
`;

const GlobalStatLabel = styled.div`
  font-size: ${FONTS.SIZE_SECONDARY};
  color: ${COLORS.BLACK_TEXT}CC;
`;

const CoverageSection = () => {
  const cities = [
    {
      name: 'Santiago',
      description: 'Cobertura activa en Santiago y principales comunas de la Región Metropolitana para fletes, traslados y coordinación logística urbana.'
    }
  ];

  return (
    <Section id="cobertura">
      <CoverageContainer>
        <SectionTitle>Cobertura en Santiago</SectionTitle>
        <Divider />
        <SectionSubtitle>
          Por ahora concentramos nuestra operación en Santiago para asegurar mejor respuesta, disponibilidad y calidad de servicio.
        </SectionSubtitle>
        
        <CitiesGrid>
          {cities.map((city, index) => (
            <CityCard key={index}>
              <CityName>
                <CityIcon><FaMapMarkerAlt /></CityIcon>
                {city.name}
              </CityName>
                             <CityDescription>{city.description}</CityDescription>
            </CityCard>
          ))}
        </CitiesGrid>
        
        <GlobalStats>
          <GlobalStatsTitle>Trineo en Cifras</GlobalStatsTitle>
          <GlobalStatsGrid>
            <GlobalStatItem>
              <GlobalStatValue>5,000+</GlobalStatValue>
              <GlobalStatLabel>Usuarios Activos</GlobalStatLabel>
            </GlobalStatItem>
            <GlobalStatItem>
              <GlobalStatValue>4.3⭐</GlobalStatValue>
              <GlobalStatLabel>Calificación Promedio</GlobalStatLabel>
            </GlobalStatItem>
          </GlobalStatsGrid>
        </GlobalStats>
      </CoverageContainer>
    </Section>
  );
};

export default CoverageSection; 